import React from "react";

const skillsContent = [
  /*{
    name: "Capacità di ascolto e intelligenza emotiva",
    skillPercent: "95",
  },*/
  {
    name: "Comunicazione e linguaggio chiaro",
    skillPercent: "80",
  },
  {
    name: "Resilienza",
    skillPercent: "90",
  },
  /*{
    name: "Problem solving anche complesso",
    skillPercent: "95",
  },*/
  {
    name: "Capacità organizzative e gestionali",
    skillPercent: "80",
  },
  {
    name: "Propensione a raggiungere risultati effettivi",
    skillPercent: "90",
  },
];

const Skills = () => {
  return (
    <>
      {skillsContent.map((val, i) => (
        <div className="progress_inner" key={i}>
          <span className="label">{val.name}</span>
          <div className="background">
            <div className="bar">
              <div
                className="bar_in"
                style={{ width: val.skillPercent + "%" }}
              ></div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Skills;
